import { createStore, StoreProvider, action } from "easy-peasy";
import Right from "./components/Right";
import Left from "./components/Left";

const store = createStore({
  calendar: [],
  dates: {
    date: null,
    month: null,
    year: null,
  },
  upcomings: [],
  isCurrentMonth: false,
  isCopticCal: false,
  copticDate: null,
  activeDate: {
    copticDate: null,
    normalDate: null,
  },
  isDarkMode: false,
  currentDate: new Date().getDate(),

  setCalendar: action((state, payload) => {
    state.calendar = payload;
  }),
  setDates: action((state, payload) => {
    state.dates = payload;
  }),
  setCopticCal: action((state, payload) => {
    state.isCopticCal = payload;
  }),
  setCopticDate: action((state, payload) => {
    state.copticDate = payload;
  }),
  setActiveDate: action((state, payload) => {
    state.activeDate = payload;
  }),
  setUpcomings: action((state, payload) => {
    state.upcomings = payload;
  }),
  setDarkMode: action((state, payload) => {
    state.isDarkMode = payload;
  }),
  setCurrentDate: action((state, payload) => {
    state.currentDate = payload;
  }),
});

function App() {
  return (
    <StoreProvider store={store}>
      <div className="App">
        <Left />
        <Right />
      </div>
    </StoreProvider>
  );
}

export default App;
